/**
 * Renders the Lucide icon for a backend achievement `icon` string. Keep the
 * map in sync with `backend/app/gamification/achievements.py` icon names.
 *
 * Exposed as a component (not a `() => Component` factory) so consumers
 * don't trip the "component created during render" lint — the lookup +
 * fallback happens here once, mirroring `SkillRow`'s ternary-icon pattern.
 */

import {
  Award,
  Clock,
  Dumbbell,
  Flame,
  ICON_STROKE,
  LineChart,
  Medal,
  Search,
  Snowflake,
  Star,
  Target,
  Trophy,
  Zap,
} from "@/shared/components/icons";

const ICON_MAP: Record<string, typeof Trophy> = {
  target: Target,
  dumbbell: Dumbbell,
  trophy: Trophy,
  search: Search,
  flame: Flame,
  medal: Medal,
  star: Star,
  zap: Zap,
  award: Award,
  // Session tracker
  "line-chart": LineChart,
  clock: Clock,
  snowflake: Snowflake,
};

export function AchievementIcon({
  name,
  size = 18,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const Icon = ICON_MAP[name] ?? Trophy;
  return <Icon size={size} strokeWidth={ICON_STROKE} className={className} />;
}
